<div class="container-fluid">
    <div class="row escritorio">
        <div class="col-12 justify-content-center">
            <ul class="nav justify-content-center">
                <li class="nav-item">
                    <a class="nav-link" href="#/">Inicio</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#/sobre-el-galardon">Sobre el galardón</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#/periodos">Años anteriores</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#/preguntas-frecuentes">Preguntas frecuentes</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#/contacto">Contáctanos</a>
                </li>
                 <li class="nav-item">
                    <a class="nav-link" href="/assets/docs/Revista_GI_2025.pdf" target="_blank">Revista 20 años</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="row mobile">
        <div class="collapse" id="navbarToggleExternalContent">
            <div class="bg-dark p-4">
                <h4 class="text-white">Collapsed content</h4>
                <span class="text-muted">Toggleable via the navbar brand.</span>
            </div>
        </div>
    </div>
</div>